export const jobLetterAdapter = () => {
  return (data) => {
    return {
      ...data,
      label: 'Job Letter',
    }
  }
}
